import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { DEFECTDOJO_PATHS } from './paths';

/** DefectDojo: щит — реестр уязвимостей. */
export const DefectDojoIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {DEFECTDOJO_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
